import { BlogPost } from '@/domain/entities/post';
import PostCard from '@/components/PostCard';

import { List, Container, Title } from './styles';

type SearchPostsListProps = {
  posts: Array<BlogPost>;
};

export default function SimilarPosts({ posts }: SearchPostsListProps) {
  return (
    <Container>
      <Title color="#2d2d2d">VOCÊ TAMBÉM PODE SE INTERESSAR POR:</Title>
      <List>
        {posts.map((post, index) => (
          <PostCard key={index} post={post} showCategory isLoading={false} />
        ))}
      </List>
    </Container>
  );
}
